const COUNTRY_MAX_RANKS = {
	Canada: 500,
	USA: 3300,
	UK: 220,
	Ireland: 80,
	Australia: 200,
	'New Zealand': 80,
	Germany: 420,
	'Saudi Arabia': 180,
	'South Korea': 350,
	Japan: 600,
	Malaysia: 250,
	Indonesia: 300,
	Singapore: 120,
	Vietnam: 150,
	'United Arab Emirates': 100,
	// NIRF rank; scale ~ number of Indian universities (UGC lists ~1,200)
	India: 1200,
}

const toNum = value => {
	if (value == null) return null
	const cleaned = String(value).trim().replace(/\s/g, '').replace(/,/g, '')
	const n = Number(cleaned)
	return Number.isFinite(n) && n > 0 ? n : null
}

/** Course row id: prefer explicit course_id, else univ_course_desc `id`. */
export const resolveUniversityCourseId = item => {
	const courses = item?.courses || {}
	return String(
		item?.course_id || courses?.course_id || courses?.id || '',
	).trim()
}

export const resolveUniversityId = item => {
	const courses = item?.courses || {}
	return String(
		courses?.university_id || item?.university_id || item?.id || '',
	).trim()
}

export const getUniversityDetailsBlockReason = ({
	universityId,
	courseId,
	programName,
} = {}) => {
	const name = String(programName || 'Unknown course').trim() || 'Unknown course'
	if (universityId && courseId) return null
	if (!universityId && !courseId) {
		return `Cannot open details for course "${name}": missing university id and course id.`
	}
	if (!universityId) {
		return `Cannot open details for course "${name}": missing university id.`
	}
	return `Cannot open details for course "${name}": missing course id.`
}

export const canOpenUniversityDetails = model =>
	Boolean(model?.universityId && model?.courseId)

export const requestUniversityDetails = (model, onViewDetails) => {
	const reason = getUniversityDetailsBlockReason(model)
	if (reason) {
		console.warn(reason)
		return false
	}
	onViewDetails?.({
		universityId: model.universityId,
		courseId: model.courseId,
		programName: model.programName,
	})
	return true
}

export function getUniversityCardModel(item) {
	const courses = item?.courses || {}
	const type = item?.type || courses?.bucket || 'target'
	const courseId = resolveUniversityCourseId(item)
	const universityId = resolveUniversityId(item)
	const programName = courses?.course_name || 'Program'
	const country = item?.country || courses?.country || ''
	const uniTitle =
		courses?.university_name ||
		item?.title ||
		courses?.university ||
		programName ||
		'University'
	const location = item?.location || courses?.location || ''
	const logo = item?.logo_s3_link || courses?.logo_s3_link
	const appDeadline =
		courses?.application_deadline || item?.application_deadline || '-'
	const fee = courses?.fees_usd
		? `$${courses.fees_usd}`
		: courses?.tution_fees
			? courses.tution_fees
			: '-'
	const ielts =
		courses?.ielts_band || courses?.ielts || courses?.ielts_score || '7'
	// Indian institutes admit through entrance exams (JEE, NEET, CUET), not IELTS,
	// so their tile shows the first listed exam; the full list goes in the hint.
	const isIndia = country.trim() === 'India'
	const entranceExams = String(item?.exams_accepted || courses?.exams_accepted || '')
		.split(/[;,]/)
		.map(exam => exam.trim())
		.filter(Boolean)
	const eligibilityTitle = isIndia ? 'Entrance Exams' : 'IELTS Eligibility'
	const eligibilityShortTitle = isIndia ? 'Exams' : 'IELTS'
	const eligibility = isIndia ? entranceExams[0] || '-' : ielts
	const eligibilityHint = isIndia ? entranceExams.join(', ') : undefined
	const coursesList = Array.isArray(item?.coursesList) ? item.coursesList : []
	// The card's own course is not "related", so only the other courses are counted.
	const relatedCount = Math.max(coursesList.length - 1, 0)
	const relatedCoursesLabel =
		relatedCount === 0
			? ''
			: relatedCount === 1
				? '+1 related course'
				: `+${relatedCount} related courses`
	const gallery = item?.gallery || courses?.gallery || []

	const qsNum = toNum(item?.rank_qs ?? courses?.rank_qs)
	const countryNum = toNum(item?.rank_country ?? courses?.rank_country)

	let rank = null
	let rankTitle = 'Ranking'
	let isImpliedRank = false

	if (qsNum) {
		rank = qsNum
		rankTitle = 'QS'
	} else if (countryNum) {
		rank = countryNum
		rankTitle = 'Country Ranking'
	} else if (
		country &&
		Object.prototype.hasOwnProperty.call(COUNTRY_MAX_RANKS, country)
	) {
		rank = COUNTRY_MAX_RANKS[country]
		rankTitle = 'QS'
		isImpliedRank = true
	}

	return {
		courses,
		type:
			type === 'dream' || type === 'target' || type === 'safe' ? type : 'target',
		courseId,
		universityId,
		programName,
		country,
		uniTitle,
		location,
		logo,
		appDeadline,
		fee,
		ielts,
		eligibilityTitle,
		eligibilityShortTitle,
		eligibility,
		eligibilityHint,
		coursesList,
		relatedCoursesLabel,
		gallery,
		rank,
		rankTitle,
		isImpliedRank,
	}
}
